export default __webpack_public_path__ + "static/image3-3e6ba630f213b70ffdd353f37e94fb4a.jpg";